import fetchAx from "@/axios.js";
import { comAxiosWithToken } from "../../utils/communucationApi";
export default {
  namespaced: true,
  state: {
    ratingTemplates: [],
    ticketRatingQuestion: [],
  },
  mutations: {
    setRatingTemplates(state, payload) {
      state.ratingTemplates = payload;
    },
    setTicketRatingQuestion(state, payload) {
      state.ticketRatingQuestion = payload;
    },
  },
  getters: {
    getRatingTemplates: (state) => state.ratingTemplates,
    getTicketRatingQuestion: (state) => state.ticketRatingQuestion,
  },
  actions: {
    async getAllRatingTemplates({ commit }) {
      await comAxiosWithToken()
        .get(`/api/RatingTemplate`)
        .then((response) => {
          commit("setRatingTemplates", response.data);
        })
        .catch((error) => {});
    },
    async addRatingTemplates({ dispatch }, myId) {
      await comAxiosWithToken()
        .post(`/api/RatingTemplate`, {
          caption: "Ticket",
          templateKey: "1",
          customerId: myId,
          maxPoint: 5,
        })
        .then((response) => {
          dispatch("getAllRatingTemplates");
        })
        .catch((error) => {});
    },
    async addQuestion({ commit, state, dispatch }, payload) {
      const { question, description } = payload;
      const rating = state.ratingTemplates.find(
        (rating) => rating.caption == "Ticket"
      );
      const data = [
        {
          question: question,
          description: description,
          ratingTemplateId: rating.id,
        },
      ];
      await comAxiosWithToken()
        .post(`/api/RatingTemplate/questions`, data)
        .then((response) => {
          dispatch("getRatingQuestions");
        })
        .catch((error) => {});
    },
    async getRatingQuestions({ commit, state }) {
      const rating = state.ratingTemplates.find(
        (rating) => rating.caption == "Ticket"
      );
      await comAxiosWithToken()
        .get(`/api/RatingTemplate/templatequestions/${rating.id}`)
        .then((response) => {
          commit("setTicketRatingQuestion", response.data);
        })
        .catch((error) => {});
    },
    async getRating({}, id) {
      return new Promise(async (resolve, reject) => {
        await comAxiosWithToken()
          .get(`/api/RatingTemplate/questions/${id}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async updateQuestion({ commit, state, dispatch }, rating) {
      const { editId, question, description } = rating;
      const ticketTemplates = state.ratingTemplates.find(
        (template) => template.caption == "Ticket"
      );
      const payload = {
        id: editId,
        question: question,
        description: description,
        ratingTemplateId: ticketTemplates.id,
      };
      await comAxiosWithToken()
        .put(`/api/RatingTemplate/questions/${editId}`, payload)
        .then((response) => {
          dispatch("getRatingQuestions");
        })
        .catch((error) => {});
    },
    async deleteQuestion({ dispatch }, id) {
      return new Promise(async (resolve, reject) => {
        await comAxiosWithToken()
          .delete(`/api/RatingTemplate/questions/${id}`)
          .then((response) => {
            dispatch("getRatingQuestions");
            resolve(200);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
